import { camelCase, upperFirst } from 'lodash';
import ResourcesParent from '@/components/rest/pages/resources/ResourcesParent.vue';
import ResourcesIndexParent from '@/components/rest/pages/resources/ResourcesIndexParent.vue';
import ResourcesIndex from '@/components/rest/pages/resources/ResourcesIndex.vue';
import ResourcesIndexCreate from '@/components/rest/pages/resources/ResourcesIndexCreate.vue';
import ResourcesIdParent from '@/components/rest/pages/resources/ResourcesIdParent.vue';
import ResourcesId from '@/components/rest/pages/resources/ResourcesId.vue';
import ResourcesIdEdit from '@/components/rest/pages/resources/ResourcesIdEdit.vue';

function nameFor(Component, NameResource) {
  return Component.name.replace('Resources', NameResource);
}

export default function restResourceRoutes(config, options = {}) {
  const {
    path, name, i18n,
  } = config.route;

  const {
    components = {},
  } = options;

  const NameResource = name
    |> camelCase
    |> upperFirst;

  const {
    IndexPage = { ...ResourcesIndex, name: nameFor(ResourcesIndex, NameResource) },
    CreatePage = { ...ResourcesIndexCreate, name: nameFor(ResourcesIndexCreate, NameResource) },
    IdPage = { ...ResourcesId, name: nameFor(ResourcesId, NameResource) },
    EditPage = { ...ResourcesIdEdit, name: nameFor(ResourcesIdEdit, NameResource) },
  } = components;

  return {
    path,
    props: { config },
    meta: { config },
    component: { ...ResourcesParent, name: nameFor(ResourcesParent, NameResource) },
    children: [{
      path: '',
      component: { ...ResourcesIndexParent, name: nameFor(ResourcesIndexParent, NameResource) },
      children: [{
        path: '',
        name: `${name}`,
        meta: {
          title: `${i18n}.meta.index.title`,
          breadcrumb: `${i18n}.meta.index.breadcrumb`,
          tab: `${i18n}.meta.index.tab`,
        },
        component: IndexPage,
      },
      {
        path: 'create',
        name: `${name}-create`,
        meta: {
          title: `${i18n}.meta.create.title`,
          breadcrumb: {
            i18n: 'pages.rest.create',
            parent: `${name}`,
          },
        },
        component: CreatePage,
      }],
    },
    {
      path: ':id',
      props: true,
      component: { ...ResourcesIdParent, name: nameFor(ResourcesIdParent, NameResource) },
      children: [{
        path: '',
        name: `${name}-id`,
        props: true,
        meta: {
          title: `${i18n}.meta.show.title`,
          breadcrumb: {
            i18n: `${i18n}.meta.show.breadcrumb`,
            parent: `${name}`,
            loading: true,
          },
          tab: {
            i18n: `${i18n}.meta.show.tab`,
            loading: true,
          },
        },
        component: IdPage,
      }, {
        path: 'edit',
        name: `${name}-id-edit`,
        props: true,
        meta: {
          title: `${i18n}.meta.show.title`,
          breadcrumb: {
            i18n: 'pages.rest.edit',
            parent: `${name}-id`,
          },
        },
        component: EditPage,
      }],
    },
    ],
  };
}
